<br />
<img class="system-logo" src="assets/images/logos/logo.png" />
<br />
<h2 class="text-center">Change Password</h2>
<br />
<div class="change-password-container clearfix">
    @if (!isExpired) {
        <form (ngSubmit)="onSubmit()" [formGroup]="changePasswordForm">
            <div>
                <pcg-show-hide-password
                    [controlName]="'password'"
                    [parentForm]="changePasswordForm"
                    label="New Password"
                    [validations]="{
                        commonPassword: 'Pick a less common password.',
                        pattern: 'Password cannot contain more than 2 repeating characters.',
                        sequentialChars: 'Password cannot contain more than 3 sequential characters.',
                    }"
                    inputCssClass="form-control"
                ></pcg-show-hide-password>
            </div>
            <div>
                <pcg-show-hide-password
                    [controlName]="'confirmPassword'"
                    [parentForm]="changePasswordForm"
                    label="Confirm New Password"
                    [validations]="{ passwordsNotEqual: 'Passwords do not match.' }"
                    inputCssClass="form-control"
                ></pcg-show-hide-password>
            </div>
            <button type="submit" class="btn btn-secondary btn-lg">Change Password</button>
        </form>
    }
    @if (isExpired) {
        <div class="text-danger text-center expired-message">{{ errorMessage }}</div>
    }
</div>
<br /><br />

<div class="text-center">
    <u>Password Requirements</u><br />
    Must be at least 10 characters in Length.<br />
    Cannot match any of the passwords in our list of commonly used passwords.<br />
    Cannot contain context-specific words such as your username or the name of the service.<br />
    Cannot use too many repeated (e.g. "aaaa") or sequential (e.g. "1234") characters.<br />
</div>
